import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { PodcastSubscribe } from './PodcastSubscribe'

export interface PodcastSubscribeRegistrationProps {
    title: string
    description?: string
    listnr?: string
    apple?: string
    spotify?: string
    youtube?: string
    youtubeMusic?: string
}

export const PodcastSubscribeRegistration = createRegisterableComponent(
    'podcast-subscribe',
    (
        {
            title,
            description,
            listnr,
            apple,
            spotify,
            youtube,
            youtubeMusic,
        }: PodcastSubscribeRegistrationProps,
        services,
    ) => {
        return (
            <PodcastSubscribe
                title={title}
                description={description}
                listnr={listnr}
                apple={apple}
                spotify={spotify}
                youtube={youtube}
                youtubeMusic={youtubeMusic}
                onEvent={services.onEvent}
            />
        )
    },
)
